export const CURRENCY_KEY_PROD_ROW = 'pk_live_8Z172qzLdb5pCqlgmF7gIosE';
export const CURRENCY_KEY_PROD_US = 'pk_live_jtXBg3UqjzZyffiOoaworbAN';
export const CURRENCY_KEY_DEV_US = 'pk_test_51R1sERC8emEtz1NS3wndZH0s3GYwZUHEQJEisBGteovLfyBJ25AO8gyj2TmoxQpiUQPYlrQLKkDu73GmgQ3nNh2k00uOar5570';
export const CURRENCY_KEY_DEV_ROW = 'pk_test_51QzIquDBzS8hJ6gUuz7LMle5f3o7Sr70JYTm8rnnEFzuAewgrbds6cRVEjbDWWU1MWufsiPwVd2xUHptBZqQjXuJ00vBmiWk4O';
